import { PaymentMethodOption } from 'api/checkout';

export default {
  'account:main-page:title': 'Hello {firstName}',

  'account:navigation:orders': 'Orders',
  'account:navigation:subscriptions': 'Recurring Deliveries',
  'account:navigation:refer-friend': 'Refer a friend',
  'account:navigation:last-order': 'Reorder last order',
  'account:navigation:credits': 'Credits',
  'account:navigation:addresses': 'Addresses',
  'account:navigation:logout': 'Log out',
  'account:navigation:bonus-program': 'Bonus Program',

  'account:bonus-program:title': 'Bonus Program',

  'account:bonus-program:sub-header': 'Your current points balance',
  'account:bonus-program:expire-information': '{amount} expire on {date}',
  'account:bonus-program:points-amount':
    '{amount, plural, =0 {# Points} one {# Point} other {# Points}}',
  'account:bonus-program:quick-links': 'Quick Links',
  'account:bonus-program:redeem-points': 'Convert points into store credit',
  'account:bonus-program:redeem-points-cta': '{pointAmount} Points <span>➡</span>    {conversion}',
  'account:bonus-program:redeem-points-fairvalue-cta':
    'Fairvalue {pointAmount} Points <span>➡</span> {conversion}',

  'account:bonus-program:donate:cta-info': '{amount} for the Berlin Animal Shelter',
  'account:bonus-program:donate:donate': 'donate',

  'account:bonus-program:product-redemption': 'Reward for bonus points',
  'account:bonus-program:product-redemption-description':
    'Your reward will be sent with your next order.',
  'account:bonus-program:mov-check-message-head': 'Oops! ',
  'account:bonus-program:mov-check-message':
    'Your shopping cart must have a minimum value of {mov} to proceed to checkout.',
  'account:bonus-program:not-enough-bonus-point':
    'You do not have enough bonus points in your account.',
  'account:bonus-program:gift-not-enough-point': '{pointAmount} points needed',
  'account:bonus-program:bp-redemption-item-succesfully-add-to-cart':
    'Your item has been successfully added to the cart.',

  'account:bonus-program:my-points:redeeem-title': 'Redeem my points',
  'account:bonus-program:my-points': 'TRANSACTION HISTORY',
  'account:bonus-program:my-points-description':
    'With just one click, you can redeem your collected points for actual <Link>credit</Link>, which will be automatically applied to your next order.',
  'account:bonus-program:action:redeem-success':
    'Your points have been successfully converted into credit.',

  'account:bonus-program:points': 'Points',
  'account:bonus-program:coins': '{transaction} Bonus Points',
  'account:bonus-program:action': 'Action',
  'account:bonus-program:acquire-date': 'Received on',
  'account:bonus-program:expire-date': 'Valid until',
  'account:bonus-program:redeem': 'Redemption',
  'account:bonus-program:refund': 'Cancellation',
  'account:bonus-program:expired': 'Points Expiry',
  'account:bonus-program:reward-order': 'Order',
  'account:bonus-program:reward-bonus': 'Bonus points',

  'account:bonus-program:info-bar:text':
    '<strong>Our bonus program is ending</strong><li>From <strong>December 31, 2025</strong>, you will <strong>no longer earn bonus points</strong>.</li><li><strong>The 12-month validity</strong> remains in effect.</li><li>Points can be redeemed until their expiration, <strong>at the latest by January 15, 2027</strong>.</li>',

  'account:orders:title': 'Orders',
  'account:orders:title-single': 'Order',
  'account:orders:reorder': 'Reorder',
  'account:orders:order-again': 'Order again',
  'account:orders:invoice': 'Invoice',
  'account:orders:download:invoice_sale': 'Download Invoice',
  'account:orders:download:invoice_refund': 'Download Correction',
  'account:orders:invoice-download-not-ready':
    'We still need to process your delivery before you can download the invoice.',
  'account:orders:tracking-invoice-available-after-shipping':
    'Invoice and shipment tracking will be available after dispatch',
  'account:orders:details': 'Details',
  'account:orders:billing-same-as-shipping': 'Same as shipping address',
  'account:orders:order-number': 'Order No.',
  'account:orders:date': 'Order date',
  'account:orders:price': 'Price',
  'account:orders:point': '{points} Points',
  'account:orders:payment-status': 'Payment status',
  'account:orders:payment-pending': 'Pending',
  'account:orders:payment-authorized': 'Authorized',
  'account:orders:payment-paid': 'Paid',
  'account:orders:payment-partially_paid': 'Partially Paid',
  'account:orders:payment-partially_refunded': 'Partially Refunded',
  'account:orders:payment-refunded': 'Refunded',
  'account:orders:payment-voided': 'Cancelled',
  'account:orders:fulfillment-status': 'Delivery status',
  'account:orders:fulfillment-fulfilled': 'Shipped',
  'account:orders:fulfillment-null': 'Pending',
  'account:orders:fulfillment-restocked': 'Returned',
  'account:orders:fulfillment-partial': 'Partially shipped',
  'account:orders:fulfillment-track-delivery': 'Track',

  'account:refer-friend:title':
    'Share, save and give: {amount} for you - {amountFriend} for your loved ones',
  'account:refer-friend:personal-link':
    '<strong> Your invitation link has been copied </strong> <br></br>Send the link to your friends now and secure your {amount} credit!',
  'account:refer-friend:email-send':
    '<strong> Your invitation has been sent </strong> <br></br>You will automatically receive your credit once your friend has placed an order.',
  'account:refer-friend:give-email-addresss': "Your friend's email:",
  'account:refer-friend:give-email-addresss-subtitle':
    "Please only enter the email address with your friend's consent.",
  'account:refer-friend:invitation-button': 'Send Invitation Now',
  'account:refer-friend:invitation-sent': 'Done!',
  'account:refer-friend:share-link': 'Or share your code via:',
  'account:refer-friend:info-intro':
    'To make sure everything goes smoothly, here are the key details:',
  'account:refer-friend:info-use-link':
    '<strong>Use your link:</strong> We can only identify your friends as referred through your personal referral link.',
  'account:refer-friend:info-min-order':
    '<strong>Minimum order value:</strong> Your friends need to spend at least €40 – easy with our selection!',
  'account:refer-friend:info-no-late-claims':
    '<strong>No late claims:</strong> Unfortunately, subsequent nominations via email or phone are not possible.',
  'account:refer-friend:info-cancellations':
    '<strong>Cancellations:</strong> If the order is cancelled or not paid, unfortunately no credit will be awarded.',
  'account:refer-friend:info-no-coupon-combo':
    "<strong>No coupon combination:</strong> Unfortunately, no additional coupons can be used with your friends' order.",
  'account:refer-friend:info-new-customers-only':
    '<strong>New customers only:</strong> Your friend must be ordering from Pets Deli for the first time.',
  'account:refer-friend:info-different-household':
    '<strong>Different household:</strong> Your friend must not live in the same household as you.',
  'account:refer-friend:email-required': 'Please fill out!',
  'account:refer-friend:email-invalid': 'Please enter a valid email address!',

  'account:credits:title': 'Credits',
  'account:credits:date': 'Date',
  'account:credits:amount': 'Amount',
  'account:credits:reason': 'Reason',
  'account:credits:balance': 'Pets Deli Credits: ',
  'account:credits:info-title': 'You have no transactions yet.',
  'account:credits:info-text':
    'If you have credits with Pets Deli, the transactions will be displayed here. You receive credits, for example, through Pets Deli promotions or credit notes.',
  'account:credits:reason-Order Application': 'Purchase',
  'account:credits:reason-Referal': 'Refer a Friend',
  'account:credits:reason-Refund': 'Refund',
  'account:credits:reason-Customer Support': 'Customer Support',
  'account:credits:reason-Bonusprogramm': 'Bonus Program',

  'account:order:title': 'Order {orderName}',

  'account:addresses:title': 'Addresses',
  'account:addresses:edit:title': 'Edit Address',
  'account:addresses:create:title': 'Add Address',
  'account:addresses:create-success': 'Address successfully added',
  'account:addresses:update-success': 'Address successfully updated',
  'account:addresses:delete-success': 'Address successfully deleted',
  'account:addresses:set-default-success': 'Address successfully set as default',
  'account:addresses:add': 'Add Address',
  'account:addresses:phone': 'Tel.: {phone}',
  'account:addresses:change': 'Change',
  'account:addresses:delete': 'Delete',
  'account:addresses:set-default': 'Set as default address',
  'account:addresses:is-default': 'Set as default',
  'account:addresses:edit-form:submit': 'Save',
  'account:addresses:create-form:submit': 'Save',

  'account:subscriptions:title': 'Recurring Deliveries',
  'account:subscriptions:details': 'Details',
  'account:subscriptions:active': 'Active',
  'account:subscriptions:paused': 'Paused',
  'account:subscriptions:cancelled': 'Ended',
  'account:subscriptions:title-title': 'Delivery <span>{shortId}</span>',
  'account:subscriptions:items-amount':
    '{amount, number} {amount, plural, one {Product} other {Products}}',
  'account:subscriptions:next-delivery': 'Next shipment',
  'account:subscriptions:interval': 'Interval',
  'account:subscriptions:price': 'Order value',
  'account:subscriptions:price:info': '(excluding potential discounts and shipping costs)',
  'account:subscriptions:interval-14': 'Every 2 weeks',
  'account:subscriptions:interval-28': 'Every 4 weeks',
  'account:subscriptions:interval-42': 'Every 6 weeks',
  'account:subscriptions:interval-56': 'Every 8 weeks',

  'account:subscription:title': 'Delivery #{shortId}',
  'account:subscription:actions:title': 'Adjust recurring delivery',
  'account:subscription:actions:next-shipping-date': 'Postpone next shipment',
  'account:subscription:actions:shipping-address': 'Change delivery address',
  'account:subscription:actions:billing-address': 'Change billing address',
  'account:subscription:actions:interval': 'Change delivery interval',
  'account:subscription:products:out-of-stock': 'Currently unavailable',
  'account:subscription:products:product-slider:title': 'Add product to delivery',
  'account:subscription:products:product-slider:subscription:button':
    'Subscribe & <span>save</span>',
  'account:subscription:products:product-slider:one-off:button': 'Order once',
  'account:subscription:products:product-slider:subscription:modal:cta-button': 'Subscribe Now',
  'account:subscription:products:product-slider:one-off:modal:cta-button': 'Order once',
  'account:subscription:products:product-slider:subscription:text':
    'Our snacks on subscription and always <strong>save 10%</strong>!',
  'account:subscription:products:product-slider:one-off:text':
    'The product will be delivered with the subscription order.',

  'account:subscription:state-change:reason:not_home':
    'I cannot receive deliveries in the near future (e.g., vacation)',
  'account:subscription:state-change:reason:still_enough': 'I still have enough products in stock',
  'account:subscription:state-change:reason:try_other':
    'I want to try other products in the near future',
  'account:subscription:state-change:reason:not_happy': 'I am dissatisfied with the current offer',
  'account:subscription:state-change:reason:by_mistake': 'Signed up by mistake',
  'account:subscription:state-change:reason:OOS': 'The product is always out of stock',
  'account:subscription:state-change:reason:expensive': 'The product is too expensive',
  'account:subscription:state-change:reason:unhappy_web': 'The website was difficult to use',
  'account:subscription:state-change:reason:too_much': 'I still have enough food at home',
  'account:subscription:state-change:reason:unhappy_CuHa':
    'I cannot reach your customer service / your food advisors',
  'account:subscription:state-change:reason:adjust': 'I want to adjust my subscription',
  'account:subscription:state-change:reason:aging': 'My pet needs different food due to age',
  'account:subscription:state-change:reason:health':
    'My pet needs different food for health reasons',
  'account:subscription:state-change:reason:food_type': 'My pet needs a different type of feeding',
  'account:subscription:state-change:reason:acceptancy': 'My pet no longer likes the food',
  'account:subscription:state-change:reason:other_supplier': 'I now order the food elsewhere',
  'account:subscription:state-change:reason:delivery': 'Bad experience with the delivery',
  'account:subscription:state-change:reason:other': 'Other reason',
  'account:subscription:state-change:reason:unhappy_web:text-placeholder':
    'What exactly bothered you?',
  'account:subscription:state-change:reason:other_supplier:text-placeholder':
    'Would you tell us where you buy the food now?',
  'account:subscription:state-change:reason:other:text-placeholder':
    'Feel free to tell us which...',

  'account:subscription:state-change:modal:reason:by_mistake:title':
    'Do you really want to give up your benefits?',
  'account:subscription:state-change:modal:reason:too_much:title':
    'Did you know that you can adjust/pause your subscription?',
  'account:subscription:state-change:modal:reason:acceptancy:title':
    'Does your pet want to try something new?',
  'account:subscription:state-change:modal:reason:aging:title':
    'We offer food for every age group!',
  'account:subscription:state-change:modal:reason:health:title':
    'Pets Deli offers food for special needs!',
  'account:subscription:state-change:modal:reason:health:sub-title':
    "For example, for allergies, weight and acceptance problems. Pets Deli supports you with your pet's health!",
  'account:subscription:state-change:modal:reason:food_type:title': 'We are here for you!',
  'account:subscription:state-change:modal:reason:food_type:sub-title':
    'Whether you want to feed dry food, wet food, BARF, or a mixed diet - at Pets Deli you will find suitable products.',

  'account:subscription:state-change:modal:info':
    'Learn more thanks to our free food consultation:',

  'account:subscription:state-change:modal:button:confirm': 'CANCEL',
  'account:subscription:state-change:modal:button:pause': 'Pause',
  'account:subscription:state-change:modal:button:adjust-date': 'Adjust date',

  'account:subscription:state-change:modal:list:item-1': '<span>10% discount</span> on every order',
  'account:subscription:state-change:modal:list:item-2': 'Always enough food at home',
  'account:subscription:state-change:modal:list:item-3': 'Flexibly adjust or pause at any time',

  'account:subscription:state-change:modal:consultation:title':
    'Get <span>free</span> advice from food experts',
  'account:subscription:state-change:modal:consultation:phone': 'Call directly ({phone})',
  'account:subscription:state-change:modal:consultation:appointment':
    'Make an appointment <span>here</span>',

  'account:subscription:state-change:cancel:navigation-title': 'Cancel Subscription',
  'account:subscription:state-change:cancel:title': 'Sorry to see you go',
  'account:subscription:state-change:cancel:description':
    'We are constantly working to make our offer even more user-friendly. Please tell us the reason for ending your recurring delivery:',
  'account:subscription:state-change:pause:navigation-title': 'Pause or postpone delivery',
  'account:subscription:state-change:pause:delivery:title':
    'Postpone your delivery to your desired period',
  'account:subscription:state-change:pause:delivery:description':
    'Do you still have enough products at home or are you going on a well-deserved vacation? Then simply postpone your next delivery by up to eight weeks to a later date!',
  'account:subscription:state-change:pause:delivery:datepicker-text':
    'Shipment of the next delivery on....',
  'account:subscription:state-change:pause:open-pause-view-cta': 'Pause delivery',
  'account:subscription:state-change:pause:delivery-cta': 'Postpone shipment',
  'account:subscription:state-change:pause:reason:title': 'Alright! One more step',
  'account:subscription:state-change:pause:reason:description':
    'We are constantly working to make our offer even more user-friendly. Please tell us the reason for pausing your recurring delivery:',
  'account:subscription:state-change:pause:reason:submit': 'Pause now',
  'account:subscription:state-change:success-message': 'Delivery status successfully changed',
  'account:subscriptions:info-button': 'Benefits of recurring delivery',
  'account:subscriptions:info-text':
    'With a recurring food delivery, you can save money every month.',
  'account:subscriptions:info-title': 'You have no active recurring delivery',

  'account:subscription:summary:interval': 'Delivery interval',
  'account:subscription:summary:next-shipping': 'Next shipment',
  'account:subscription:summary:billing-address-equal-shipping-address': 'matches delivery address',
  'account:subscription:summary:shipping-method': 'Shipping method',
  'account:subscription:summary:status': 'Status',
  'account:subscription:summary:payment-method:credit-card': 'Credit Card',

  'account:subscription:items-quantity-change:success-message': 'Quantity successfully changed',
  'account:subscription:item-recover:success-message': 'The product was successfully added',
  'account:subscription:next-shipping:title': 'Postpone shipment',
  'account:subscription:next-shipping:current-value': 'Current shipping date',
  'account:subscription:next-shipping:new-value': 'New shipping date',
  'account:subscription:next-shipping:save-button': 'Postpone shipment',
  'account:subscription:next-shipping:success-message': 'Delivery successfully postponed',
  'account:subscription:interval:title': 'Change delivery interval',
  'account:subscription:interval:current-interval': 'Current interval',
  'account:subscription:interval:new-interval': 'New interval',
  'account:subscription:interval:save': 'Change delivery interval',
  'account:subscription:interval:success-message': 'Delivery interval successfully changed',
  'account:subscription:shipping-address:title': 'Change delivery address',
  'account:subscription:billing-address:title': 'Change billing address',
  'account:subscription:shipping-address:success-message': 'Delivery address successfully changed',
  'account:subscription:addresses:new-address': 'Add new address',
  'account:subscription:addresses:select-cta': 'Ship to this address',

  'account:subscription:add-item-cta': '+ Add another product',

  'account:subscription:status-action:cancel': 'Cancel',
  'account:subscription:status-action:pause': 'Pause',
  'account:subscription:status-action:procede': 'Resume',

  'account:subscription:remove-item': 'Remove product',
  'account:subscription:add-item-again': 'Add again',
  'account:subscription:active-products': 'Active Products',
  'account:subscription:deleted-products': 'Removed Products',
  'account:subscription:modal:delete-item:title':
    'Are you sure you want to remove this product from your subscription?',
  'account:subscription:modal:delete-item:subtitle':
    ' This product will be removed from the subscription. You can see the removed product in the overview above.',
  'account:subscription:modal:delete-item:cancel': 'Keep the product',
  'account:subscription:modal:delete-item:confirm': 'Yes, remove the product',

  'account:subscription:modal:question':
    'Your delivery is currently inactive. Do you want to receive this delivery again?',
  'account:subscription:modal:confirmation': 'Yes, activate delivery',
  'account:subscription:modal:rejection': 'No',

  'account:reset:page-title': 'Set new password',

  'account:subscription:one-time:more-details': 'More Details',
  'account:subscription:in-process': 'In Progress',
  'account:subscription:run-immediately': 'Run Immediately',
  'account:subscription:execute-now-confirmation:title':
    'Are you sure you want to run your savings subscription now?',
  'account:subscription:execute-now-confirmation:message': 'Price and estimated delivery date',
  'account:subscription:execute-now-confirmation:info-card:total-label': 'Total amount incl. VAT',
  'account:subscription:execute-now-confirmation:info-card:delivery-date-label':
    'Estimated delivery date',
  'account:subscription:execute-now-confirmation:info-card:delivery-date-pending':
    'Being calculated',
  'account:subscription:execute-now-confirmation:yes': 'Confirm',
  'account:subscription:execute-now-confirmation:no': 'Cancel',
  'account:subscription:deliver-ondemand:confirmation':
    'Your shipment will be started immediately.{br}Anything else?',
  'account:subscription:deliver-ondemand:oos:confirmation': 'Some products are unavailable',
  'account:subscription:deliver-ondemand:oos:confirmation:all-items-oos':
    'Unfortunately all products in your savings subscription are sold out',
  'account:subscription:deliver-ondemand:oos:confirmation:message':
    'Do you want to receive your order without these products?',
  'account:subscription:deliver-ondemand:oos:confirmation:message-all-items-oos':
    'Do you want to create a new order?',
  'account:subscription:deliver-ondemand:oos:confirmation:button:all-items-oos':
    'Discover other products',
  'account:subscription:deliver-ondemand:oos:badge': 'Sold out',
  'account:subscription:deliver-ondemand:success-toast': 'Your order will be processed today!',
  'account:subscription:deliver-ondemand:confirmation-speed-delivery': 'Confirm',
  'account:subscription:deliver-ondemand:confirmation-contain-oos': 'Continue',
  'account:subscription:deliver-ondemand:confirmation-added-item': 'Added',
  'account:subscription:speed-delivery-subtitle':
    '*The product will be delivered with the subscription order.',
  'account:subscription:deliver-ondemand:customise-subscription': 'Adjust savings subscription',
  'account:subscription:info-bar:text':
    '<span>Or browse products and add them directly to your subscription. More in the <a>FAQ</a></span>',

  'account:subscription:payment-reauthorisation:header':
    'Please authorize a payment method for your subscription',
  'account:subscription:payment-reauthorisation:body':
    'We have changed our payment provider.{br}Please authorize one of the following payment methods to ensure your future recurring deliveries.',
  'account:subscription:payment-reauthorisation:saved-payment-method':
    'Your current payment information:',
  'account:subscription:payment-reauthorisation:new-payment-method':
    'Choose a payment method for your subscription:',
  'account:subscription:payment-reauthorisation:button:confirm': 'Confirm',
  [`account:subscription:payment-reauthorisation:option:${PaymentMethodOption.CreditCard}`]: 'Card',
  [`account:subscription:payment-reauthorisation:option:${PaymentMethodOption.PayPal}`]: 'PayPal',
  'account:subscription:payment-reauthorisation:current-payment-method':
    'Use the current payment method',
  'account:subscription:mov-modal:your request failed': 'Your request failed',
  'account:subscription:mov-modal:make sure your subtotal is':
    'Please make sure that the subtotal {br} of your purchase is over {mov}.',
  'account:subscription:mov-modal:why-mov': 'Why {mov} minimum order value?',
  'account:subscription:mov-modal:mov-explanation':
    'Every package and shipment causes CO2 emissions. By ensuring that packages have a certain size, we automatically reduce packaging waste and emissions, thus making a small contribution to environmental protection. {br} {br} Thank you for your help!',
  'account:subscription:mov-modal:request help': 'Request help from customer service',
  'account:subscription:one-off-item-info':
    'This product is not reserved for you. To make sure you receive it, select the option <strong>Run Immediately</strong>.',
  'account:subscription:price-summary:active-until': 'Active until {activeUntil}',
  'account:subscription:price-summary:shipping-price': '* €',
  'account:subscription:price-summary:shipping-info':
    '*<b>Shipping costs</b> are recalculated for every order. Free delivery from €60.',
  'account:subscription:price-summary:credit-info':
    '<b>Credit</b> is only applied when the order is created.',
  'account:upsell-product:cta': 'Add to order',
  'account:upsell-product:cta-item-added': 'Added',

  'account:pet-profile:title:with-name': "{name}'s best choice",
  'account:pet-profile:title:with-multiple-pets': 'The best choice for {names}',
  'account:pet-profile:title:with-multiple-pets-others': ' & Co.',
  'account:pet-profile:title:without-name': 'Already the right food?',
  'account:pet-profile:subtitle:with-name': "Check out {name}'s individual product selection!",
  'account:pet-profile:subtitle:without-name': 'Find out – with our personalized recommendation!',
  'account:pet-profile:subtitle:with-multiple-pets':
    'Check out their individual product selection!',
};
